import requestData, {setFormData,setURLSearchParams,middleErrorInfo,formatterData} from "@/http/request";
export function searchContactRequest({ search = '', inquiry_user_id }) {
  const data = Object.entries({
    search,
    inquiry_user_id,
  }).filter(i=> !['[object Null]','[object Undefined]'].includes(toString.call(i[1])) && String(i[1])).reduce((total,item)=>{
    total[item[0]] = item[1]
    return total
  },{})
  return requestData('/apsapi/InquiryOrderEnter/inquiryUsreList','POST', data)
}
export function inquiryOrderEnterRequest({
  car_type,
  part_list=[
    {
      part_name:'',
      quality:'',
      part_num:0,
      part_remark:'',
      part_cs:'',
      is_goods:'',
      part_price:'',
    }
  ],
  vin = '',
  plate_no = '',
  report_no = '',
  end_time = '',
  user_id = '',
  brand_code = '',
  brand_name = '',
  model_name = '',
  system_name = '',
  group_name = '',
  invoice_flag = '',
  invoice_type = '',
  remark = '',
  stagingId,
}){
  const data = {
    stagingId,
  }
  const sendData = {
    car_type,
    part_list,
    vin,
    plate_no,
    report_no,
    end_time,
    user_id,
    brand_code,
    brand_name,
    model_name,
    system_name,
    group_name,
    invoice_flag,
    invoice_type,
    remark,
  }
  Object.entries(data).forEach(item=>{
    if(item[1]) sendData[item[0]] = item[1]
  })
  return requestData('/apsapi/InquiryOrderEnter/inquiryOrderEnter','POST',sendData)
}

export function checkPointsHaveRequest() {
  return requestData('/queryPrice/checkPointsHave?rule_flag=cxvin','POST')
}
export function vagueGetMsgByVin({ vin, plateNo, enquiryNo }){
  return requestData('/queryPrice/vagueGetMsgByVin','POST',{
    vin, plateNo, enquiryNo
  })
}

/**
 * 获取保险公司列表
 * 
 * 如果获取总公司列表，什么都不用传；
 * 如果获取分公司列表，需要传一个ins_id传总公司id；
 * 如果获取中支，parent_id传分公司，ins_is传总公司。
 * 
 * @param ins_id 总公司ID
 * @param parent_id 分公司ID
 */
export function getInsListRequest({ ins_id, parent_id }){
// 第一次什么都不传，先传保险公司id，再传父级id
  const data = {}
  Object.entries({ ins_id, parent_id }).forEach(item=>{
    const itemNum = Number(item[1])
    if(!isNaN(itemNum) && itemNum>0) data[ item[0] ] = item[1]
  })
  return requestData('/apsapi/InquiryOrderEnter/getInsList','POST',data)
}
export function addInquiryUserRequest({
  f_Name,
  ins_id,
  f_manager_name,
  f_mobile,
  password,
}){
  return requestData('/apsapi/InquiryOrderEnter/addInquiryUser','POST',{
    f_Name,
    ins_id,
    f_manager_name,
    f_mobile,
    password,
  })
}
export function jnpplistbyletterRequest({
  hot_car_type='', /**1:乘用  2:商用 */
  character='',
}){
  const data = Object.entries({ hot_car_type, pycx: character, }).filter(i=>{
    if(['[object Null]', '[object Undefined]'].includes(toString.call(i[1]))) return false
    if(['[object String]'].includes(toString.call(i[1]))) return i[1]
    return true
  }).reduce((total, item)=>{
    total[ item[0] ] = item[1]
    return total
  }, {})
  return requestData('/weChat/jnpplistbyletter','POST', data )
}
export function queryCarSeries({ brandCode }){
  return requestData('/Queryprice/querychexi','GET',{ ppId: brandCode })
}
export function queryCarGroup({ seriesCode }){
  return requestData('/queryPrice/queryCheZu','GET',{ cxId: seriesCode })
}
export function queryCarModel({ groupCode }){
  return requestData('/queryPrice/queryCheXing','GET', { czId: groupCode })
}
export function getVinLog(){
  return requestData('/apsapi/InquiryOrderEnter/getVinLog')
}

documentStaging.TYPE_ID_RESULT = {
  INQUIRY:1,
  ORDER:2,
}
export function documentStaging({
  type_id = 0,
  vin = '',
  plate_no = '',
  data = {},
  id = null,
}){
  const dataFilter = Object.entries({
    type_id,
    vin,
    plate_no,
    data,
    id,
  }).filter(i=> ![ '[object Null]', '[object Undefined]', ].includes(toString.call(i[1])))
    .reduce((total,item)=>{
      total[ item[0] ] = item[1]
      return total
    },{})
  return requestData('/apsapi/InquiryOrderEnter/documentStaging','POST',dataFilter)
}
documentStagingList.TYPE_ID_RESULT = documentStaging.TYPE_ID_RESULT
export function documentStagingList({
  type_id= 0,
  vin = '',
  plate_no = '',
  page=1,
  page_size=10,
}){
  const dataFilter = Object.entries({
    type_id,
    vin,
    plate_no,
  }).filter(i=> ![ '[object Null]', '[object Undefined]', ].includes(toString.call(i[1])))
    .reduce((total,item)=>{
      if(item[1]) total[ item[0] ] = item[1]
      return total
    },{})
  return requestData('/apsapi/InquiryOrderEnter/documentStagingList','POST',{
    ...dataFilter,
    page,
    page_size,
  })
}
export function documentStagingInfo({ id, }){
  return requestData('/apsapi/InquiryOrderEnter/documentStagingInfo','POST',{ id })
}

/**
 * 订单录入
 * @param vin
 * @param car_type 商乘类型 1 乘用车 2 商用车
 * @param plate_no
 * @param report_no 报案号
 * @param user_id
 * @param brand_code
 * @param brand_name
 * @param model_name
 * @param system_name
 * @param group_name
 * @param invoice_flag 是否开发票 0否，1是
 * @param invoice_type 发票类型 1普通发票2专用发票
 * @param customer 客户名称
 * @param customer_phone 客户电话
 * @param customer_name 客户姓名
 * @param freight
 * @param tax_point
 * @param aps_pay_type 支付选项 1 修理厂付款 2 保险直赔
 * @param pay_status 支付状态 0未支付 1已支付
 * @param inquiry_id
 * @param logistics_sn 物流单号
 * @param logistics_company 物流公司名
 * @param logistics_contact 物流联系方式
 * @param logistics_intro 发货说明
 * @param logistics_voucher 物流快照，一个图片链接
 * @param remark
 * @param stagingId
 * @param partList Array -> Object {
 *   part_id
 *   part_name
 *   quality
 *   part_price
 *   part_num
 *   part_remark
 *   part_cs 厂商
 *   is_goods 是否现货 1：有现货 2：无现货
 * }
 * @returns {*}
 */
export function orderEnter({
  vin,
  car_type,
  plate_no,
  report_no,
  user_id,
  brand_code,
  brand_name,
  model_name,
  system_name,
  group_name,
  invoice_flag,
  invoice_type,
  customer,
  customer_phone,
  customer_name,
  customer_address,
  address_id,
  freight,
  tax_point,
  aps_pay_type,
  pay_status,
  inquiry_id,
  logistics_sn,
  logistics_company,
  logistics_contact,
  logistics_intro,
  logistics_voucher,
  remark,
  stagingId,
  part_list=[ ],
  account_id,
}) {
  const data = {
    vin,
    car_type,
    plate_no,
    report_no,
    brand_code,
    brand_name,
    model_name,
    system_name,
    group_name,
    invoice_flag,
    invoice_type,
    customer,
    customer_phone,
    customer_name,
    customer_address,
    address_id,
    freight,
    tax_point,
    aps_pay_type,
    pay_status,
    logistics_sn,
    logistics_company,
    logistics_contact,
    logistics_intro,
    logistics_voucher,
    remark,
    part_list: JSON.stringify(part_list),
    account_id,
  }
  Object.entries({
    inquiry_id,
    user_id,
    stagingId,
  }).forEach(item=>{
    if(item[1]) data[ item[0] ] = item[1]
  })
  const filterData = Object.entries(data).filter(i=>!['[object Null]','[object Undefined]'].includes(toString.call(i[1]))).reduce((total, item)=>{
    total[ item[0] ] = item[1]
    return total
  },{})
  return requestData('/apsapi/InquiryOrderEnter/orderEnter','POST',filterData)
}

export function uploadstartMulti({
  file
}) {
  return requestData('/plugin/uploadstartMulti','POST',{
    inquiry_id:null,
    mtype: 3,
    'file[]':file,
  })
}
export function importOrder({
  file,
  user_id,
}) {
  return requestData('/apsapi/InquiryOrderEnter/importOrder','POST',{
    file,
    user_id,
  })
}